module.exports = __webpack_public_path__ + "media/images/writer/community/sp-headline-about-rule-81b1cfcf4f64f294b475922e5dde221c.png";